import { useEffect } from 'react';
import styled from '@emotion/styled';
import { useDispatch, useSelector } from 'react-redux';
import { Spacings } from '@styles/index';
import {
  getEducatorLevelInfo,
  getEducatorLevelStats
} from '@selectors/educator';
import Image from '@base/Image';
import P1 from '@base/P1/P1';
import { fetchEducatorLevelStats } from '@actions/educator';
import H6 from '@base/H6/H6';
import isEmptyObject from '@utils/isEmptyObject';
import useLevelDisplayInfo from '@api/hooks/profile/useLevelDisplayInfo';
import { getLevelAsset } from './utils';

const StatsContainer = styled.div`
  margin-top: ${Spacings.SPACING_8B};
  grid-column: 1/11;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const BadgeContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${Spacings.SPACING_5B};
`;

const BadgeBox = styled.div`
  display: flex;
`;

const StyledP1 = styled(P1)`
  color: var(--color-i-white-v2);
`;

const StyledH6 = styled(H6)`
  margin-left: ${Spacings.SPACING_2B};
`;

const Badge = styled(Image)`
  cursor: pointer;
`;

const LevelStats = () => {
  const dispatch = useDispatch();
  const levelStats = useSelector(getEducatorLevelStats);
  const levelInfo = useSelector(getEducatorLevelInfo);
  const { levelsDisplayInfo = [] } = useLevelDisplayInfo();

  useEffect(() => {
    if (isEmptyObject(levelStats)) {
      if (levelInfo.goal?.uid)
        dispatch(fetchEducatorLevelStats(levelInfo.goal.uid));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <StatsContainer>
      {levelStats.levels?.map((level) => (
        <BadgeContainer key={level.index}>
          <BadgeBox>
            <Badge
              src={getLevelAsset(levelsDisplayInfo, level.level_id).badge}
              width={20}
              height={20}
              alt={level.display_text}
            />
            <StyledH6>{level.display_text}</StyledH6>
          </BadgeBox>
          <StyledP1>{level.percentile_threshold}</StyledP1>
        </BadgeContainer>
      ))}
    </StatsContainer>
  );
};

export default LevelStats;
